import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EngagementType } from '@interfaces';
import { CommonEngagementGridPart } from '../../../../../../../ui/widget';
import { AccCohortPageService } from '../../../acc-cohort.page.service';


@Component({
	selector: 'acc-completed-engagements-view-part',
	standalone: true,
	imports: [CommonEngagementGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-completed-engagements-view.part.html',
})
export class AccCompletedEngagementsViewPart implements OnInit {

	public readonly pageService = inject(AccCohortPageService);
	public engagements = computed(() => this.pageService.engagements()?.filter(t => t.closedUTC) ?? []);

	ngOnInit() {
		this.pageService.engagementType.set(EngagementType.closed);
	}
}